import { n as e, t } from "./apiUrls-D1kwi47F.js";
import { a as n, c as r, d as i, f as a, i as o, l as s, n as c, o as l, r as u, s as d, t as f, u as p } from "./usePrintingService-C3rXEuQq.js";
import { t as m } from "./dist-D_K97d06.js";
//#region \0rolldown/runtime.js
var h = Object.defineProperty, g = /* @__PURE__ */ ((e, t) => {
	let n = {};
	for (var r in e) h(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || h(n, Symbol.toStringTag, { value: "Module" }), n;
})({}), _ = (e, t) => {
	let n = e.message;
	if (n) switch (n.case) {
		case m.Printed:
			t.onPrinted?.();
			break;
		case m.PrintErrored:
			t.onPrintErrored?.();
			break;
	}
};
//#endregion
export { g as events, c as getPrinterGroups, u as getPrinters, o as getStatus, _ as matchPrintingEvent, n as postAllowShopsAccessToPrinterGroup, l as postAssignPrinterToGroup, d as postCreatePrinterGroup, r as postEnableDirectPrinting, s as postRemovePrinterGroup, p as postRenamePrinterGroup, i as postSyncPrinters, a as postUnassignPrinterFromGroup, t as printingApiAcceptanceUrl, e as printingApiUrl, f as usePrintingService };
